<template>
  <div class="container-fluid">
    <v-row class="header" ref="header">
      <!-- <v-col cols="12" sm="12" md="4" class="text-left" ref="inputBusca">
        <v-text-field
          v-model="search"
          append-icon="search"
          @click:append="searchTerm"
          clear-icon="mdi-close-circle"
          label="O que você quer aprender?"
          height="2"
          type="text"
          color="grey darken-1"
          placeholder="O que você quer aprender?"
          solo
          flat
          rounded
          class="search-top-public"
          style="width: 300px;"
        ></v-text-field>
      </v-col> -->

      <v-col cols="12" sm="12" md="4">
      </v-col>

      <v-col cols="12" sm="12" md="4" class="text-center" ref="logoHeader">
        <img class="logo" src="@/assets/lp/images/mundi-play-logo.png" alt="MundiPlay Logo" @click="goToHome" />
        <a href="/login" target="_blank" class="btn-login-mobile"><v-icon>person_outline</v-icon></a>
      </v-col>

      <v-col cols="12" sm="12" md="4" class="text-right" ref="btnsHeader">
        <ul class="header-btns">
          <li><router-link :to="{name: 'login-enter'}" target="_blank" class="btn">Entre</router-link></li>
          <li><router-link :to="{ name: 'course-create-step1' }" target="_blank" class="btn">Ensine com a gente</router-link></li>
        </ul>
      </v-col>

      <v-col cols="12" sm="12" class="search-top text-left" ref="inputBusca">
        <h2>Aprender sempre, a cada momento<br /> e em todo lugar!</h2><br/>

        <v-text-field
          v-model="search"
          append-icon="search"
          @click:append="searchTerm"
          @keydown.enter="searchTerm"
          clear-icon="mdi-close-circle"
          label="O que você quer aprender?"
          height="2"
          type="text"
          color="grey darken-1"
          placeholder="O que você quer aprender?"
          solo
          flat
          class="search-top-public"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'PublicHeader',
    props: {
      term: {
        type: String,
        required: false,
        default: ''
      }
    },
    data () {
      return {
        termValue: '',
        pageWidth: ''
      }
    },
    computed: {
      search: {
        get: function () {
          return this.term
        },
        set: function (val) {
          this.termValue = val
        }
      }
    },
    created () {
      this.termValue = this.term
    },
    beforeMount() {
      this.responsiveHeader()
    },
    mounted() {
      window.onresize = this.responsiveHeader;
    },
    methods: {
      ...mapActions(['setPublicFilters']),
      searchTerm () {
        this.setPublicFilters({
          term: this.termValue
        }).then(() => {
          this.$emit('doSearch')
        })
      },
      goToHome () {
        if (this.$route.name !== 'landing') {
          this.$router.push({ name: 'landing' })
        }
      },
      responsiveHeader () {
        // muda a posicao do logo e busca do header
        // this.pageWidth = window.innerWidth;

        // setTimeout(() => {
        //   if (this.pageWidth > 1050 && !this.$refs.header.classList.contains('header-desk')) {
        //     this.$refs.header.classList.remove('header-mobile')
        //     this.$refs.header.classList.add('header-desk')
        //     this.$refs.header.insertBefore(this.$refs.inputBusca, this.$refs.logoHeader);
        //   }

        //   if (this.pageWidth < 1050 && !this.$refs.header.classList.contains('header-mobile')) {
        //     this.$refs.header.classList.remove('header-desk')
        //     this.$refs.header.classList.add('header-mobile')
        //     this.$refs.header.insertBefore(this.$refs.logoHeader, this.$refs.inputBusca);
        //   }
        // }, 300);
      }
    }
  }
</script>

<style scoped>

</style>
